import React, { useContext, useEffect } from 'react';
import mainContext from '../../contexts/mainContext';
import NotificationListCard from './NotificationListCard'
const Notifications = () => {
    const context = useContext(mainContext);
    const { setProfileNavTitle } = context;
    useEffect(() => {
        setProfileNavTitle("Notification");
        // eslint-disable-next-line
    }, [])
    return (
        <>
            <div className="notification_main_div">
                <div className="list_header notifications_list_grid">
                    <div>
                        <div>Status</div>
                    </div>
                    <div>Notification</div>
                    <div style={{ textAlign: "right" }} >issued from</div>
                    <div style={{ textAlign: "right" }}>Date & time</div>
                    <div></div>
                </div>
                <div>
                    <NotificationListCard status={true} />
                    <NotificationListCard status={true} />
                    <NotificationListCard status={false} />
                </div>
            </div>
        </>
    )
}

export default Notifications
